module.exports = __webpack_public_path__ + "img/reju5.c7e12961.png";